module.exports = __webpack_public_path__ + "img/1920_clj.069d159c.png";